export const customersQuery = [
	"utm_source",
	"utm_medium",
	"utm-campaign",
	"utm_content",
	"utm_term",
	"fbclid",
	"mktdata",
];
